import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import BottomNav from "./components/BottomNav";
import { ToastProvider } from "./components/base/Toast";
import PageTransition from "./components/PageTransition";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ToastProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <PageTransition>
            <AppRoutes />
            <BottomNav />
          </PageTransition>
        </BrowserRouter>
      </ToastProvider>
    </I18nextProvider>
  );
}

export default App;